import { render, staticRenderFns } from "./Strains.vue?vue&type=template&id=48cd9c86&"
import script from "./Strains.vue?vue&type=script&lang=js&"
export * from "./Strains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports